// Creates a DOM friendly string for use as an element ID
export function createElementID(value: string): string {
    if (value == null) {
        return '';
    }

    const regex = new RegExp(/[^a-zA-Z0-9_]/, 'gi');
    return value.replace(regex, '_');
}
